import type { ApiHelper, ApiResponseWithData, BaseRequest } from '..';
import { ApiHelperWithData, splitParams } from '..';
import type {
  ApndFileInfo,
  ApndFileSave,
  ApndUploadedFile,
  ContractSalesDetail,
  ContractSalesList,
  CsesSave_Params1,
  CsesSave_Params2,
  CsesSave_Params3,
  PagerData,
} from '../model';

/*
 * 견적관리 API
 */
export class ContractSalesApi {
  private withData: ApiHelperWithData;
  constructor(helper: ApiHelper) {
    this.withData = new ApiHelperWithData(helper);
  }

  // 목록 조회
  list = (
    params: {
      startDt: string;
      endDt: string;
      bzClsfCd?: string;
      prgsStatCd?: string;
      ceCoCd?: string;
      ceCoNm?: string;
      prjtNm?: string;
      rowsPerPage: number;
      pageNumber: number;
      sortColumn?: string;
      sortDir?: 'asc' | 'desc';
    } & BaseRequest,
  ): Promise<ApiResponseWithData<{ list: PagerData<ContractSalesList> }>> => {
    const url = '/apis/contract-sales/list';
    return this.withData.postJson(url, ...splitParams(params));
  };

  // 상세 조회
  detail = (
    params: {
      csesId: string;
    } & BaseRequest,
  ): Promise<ApiResponseWithData<{ detail: ContractSalesDetail }>> => {
    const url = '/apis/contract-sales/info';
    return this.withData.postJson(url, ...splitParams(params));
  };

  // 등록
  create = (
    params: {
      params1: CsesSave_Params1;
      params2: CsesSave_Params2[];
      params3: CsesSave_Params3[];
      files: ApndFileSave[];
    } & BaseRequest,
  ): Promise<ApiResponseWithData<{ instCnt: number }>> => {
    const url = '/apis/contract-sales/insert';
    return this.withData.postJson(url, ...splitParams(params));
  };

  // 수정
  update = (
    params: {
      params1: CsesSave_Params1;
      params2: CsesSave_Params2[];
      params3: CsesSave_Params3[];
      files: ApndFileSave[];
    } & BaseRequest,
  ): Promise<ApiResponseWithData<{ instCnt: number }>> => {
    const url = '/apis/contract-sales/update';
    return this.withData.postJson(url, ...splitParams(params));
  };

  // 삭제
  delete = (
    params: {
      csesId: string;
    } & BaseRequest,
  ): Promise<ApiResponseWithData<{ delCnt: number }>> => {
    const url = '/apis/contract-sales/delete';
    return this.withData.postJson(url, ...splitParams(params));
  };

  // 파일 업로드
  uploadFile = (
    params: {
      file: Blob;
      fileName: string;
    } & BaseRequest,
  ): Promise<ApiResponseWithData<ApndUploadedFile>> => {
    const [data, extra] = splitParams(params);
    const formData = new FormData();
    formData.append('file', data.file, data.fileName);
    const url = '/apis/contract-sales/upload';
    return this.withData.postMultipart(url, formData, extra);
  };

  // 파일 삭제 (임시 파일 정리)
  deleteFile = (
    params: {
      fileId: string;
    } & BaseRequest,
  ): Promise<ApiResponseWithData<void>> => {
    const url = '/apis/contract-sales/delete-file';
    return this.withData.postJson(url, ...splitParams(params));
  };

  dialogList = (
    params: {
      keyword?: string;
    } & BaseRequest,
  ): Promise<ApiResponseWithData<{ list: ContractSalesList[] }>> => {
    const url = '/apis/contract-sales/dialog-list';
    return this.withData.postJson(url, params);
  };
}
